import { Vue, Component } from 'vue-property-decorator';
import { readUserProfile } from '@/store/main/getters';
import { IUserProfile } from '@/interfaces';
import { store } from '@/store';
import { readHasAdminAccess } from '@/store/main/getters';
import { mixin } from 'vue/types/umd';

@Component
export default class PrivilegeMixin extends Vue {
  public hasPrivilege(privileges: string, requiredPriv: string) {
    const privilegeList: string[] = privileges.split('|');
    return privileges.indexOf(requiredPriv) !== -1;
  }
  // This call checks the privileges against the user record roles
  public roleCheck(requiredPriv: string, accessLevel: string) {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    // console.log('roleCheck', requiredPriv, accessLevel);
    if (rec) {
      if (rec.is_superuser) {
        if (rec.rolemap) {
          const privilegesKey = 'privileges';
          // console.log('roleCheck', requiredPriv, accessLevel, rec.rolemap[privilegesKey]);
          if (!rec.rolemap[accessLevel]) {
            console.log('roleCheck accessLevel not found', accessLevel, rec.rolemap);
          } else if (!this.hasPrivilege(rec.rolemap[privilegesKey], requiredPriv)) {
            console.log('roleCheck privilege not found', requiredPriv, rec.rolemap[privilegesKey]);
          }
        }
        return true;
      }
      if (rec.rolemap) {
        // console.log('roleCheck', requiredPriv, accessLevel, rec.rolemap[accessLevel]);
        if (rec.rolemap[accessLevel] == null) {
          return false;
        } else {
          console.log('roleCheck', requiredPriv, accessLevel, rec.rolemap[accessLevel], this.hasPrivilege(rec.rolemap[accessLevel], requiredPriv));
          return this.hasPrivilege(rec.rolemap[accessLevel], requiredPriv);
        }
      } else {
        console.log('roleCheck: no rolemap found!', rec);
        return false;
      }
    } else {
      console.log('roleCheck: no user rec found!');
      return false;
    }
  }

  public roleCheckNavBar(requiredPriv: string): boolean {

    const rec: IUserProfile | null = readUserProfile(this.$store);
    // console.log('roleCheckNavBar', requiredPriv, rec);
    const accessLevel = 'read';
    if (rec) {
      if (rec.is_superuser) {
        if (rec.rolemap && !rec.rolemap[accessLevel]) {
          console.log('roleCheckNavBar accessLevel not found', accessLevel, rec.rolemap);
        }
        return true;
      }
      if (rec.rolemap) {
        // console.log('roleCheckNavBar', requiredPriv, rec.rolemap[accessLevel], rec.rolemap);
        if (rec.rolemap[accessLevel] == null) {
          return false;
        } else {
          // console.log('roleCheckNavBar', requiredPriv, access, rec.rolemap[accessLevel]);
          return this.hasPrivilege(rec.rolemap[accessLevel], requiredPriv);
        }
      }
    }
    return false;
  }

  public getUser(): IUserProfile | null {

    const rec: IUserProfile | null = readUserProfile(this.$store);
    return rec;
  }

  // public roleCheckAPI(accessPath: string, apiName: string): boolean {

  //   const rec: IUserProfile | null = readUserProfile(this.$store);
  //   if (rec) {
  //     // console.log('roleCheckAPI', accessPath, apiName, rec, rec.is_superuser);
  //     if (rec.is_superuser) {
  //       return true;
  //     }
  //     if (rec.rolemap) {
  //       // console.log('roleCheckAPI', accessPath, apiName, rec.rolemap[accessPath]);
  //       if (rec.rolemap[accessPath] == null || rec.rolemap[accessPath].api == null) {
  //         return false;
  //       } else {
  //         const endpoints: string[] = rec.rolemap[accessPath].api;
  //         if (endpoints.includes(apiName)) {
  //           return true;
  //         }
  //         // console.log('roleCheckAPI', accessPath, apiName, endpoints, rec.rolemap[accessPath]);
  //         return false;
  //       }
  //     }
  //   }
  //   return false;
  // }

  public roleCheckIsA(roles: string): boolean {
    const rec: IUserProfile | null = readUserProfile(this.$store);
    if (rec) {
      // console.log('roleCheckIsA', rec.userrole_name, roles, roles.split('|').includes(rec.userrole_name));
      if (rec.userrole_name !== 'super') {
        return roles.split('|').includes(rec.userrole_name);
      }
    }
    return true;
  }

  public isSuperUser() {
    return readHasAdminAccess(store);
  }
}
